import { render, staticRenderFns } from "./AlertsPopup.vue?vue&type=template&id=229bb69c&"
import script from "./AlertsPopup.vue?vue&type=script&lang=js&"
export * from "./AlertsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports